import { getAppConfig } from '@services/config';
import { apiHttpService } from '@services/http';

import { contractsRepository } from '@repositories/contracts';

import { ApiContactDetailsType, ApiPersonDetailsType } from '@app-types/api/person';
import { ContactDetailsType, PersonDetailsType } from '@app-types/person';
import { ForbiddenUserType, UserType, UserTypeEnum } from '@app-types/user';

class PersonRepository {
    url: string;

    public constructor(url: string) {
        this.url = url;
    }

    public async getContactDetails(id: string, user: UserType): Promise<ContactDetailsType | undefined> {
        return await apiHttpService
            .get<ApiContactDetailsType>(`${this.url}/personnes/${id}/coordonnees`, undefined, {
                user,
            })
            .then((response) => {
                return {
                    address: {
                        zipCode: response.adressesPostales?.[0]?.codePostal,
                        city: response.adressesPostales?.[0]?.ville,
                    },
                };
            })
            .catch(() => {
                return undefined;
            });
    }

    public async getPersonDetails(id: string, user: UserType): Promise<PersonDetailsType | undefined> {
        return await apiHttpService
            .get<ApiPersonDetailsType>(`${this.url}/personnes/${id}`, undefined, {
                user,
            })
            .then((response) => {
                return {
                    id: response.id,
                    type: response.type,
                };
            })
            .catch(() => undefined);
    }

    public async getIdPuFromContract(user: UserType, contract?: string): Promise<string | undefined> {
        const userType = user.user_type as UserTypeEnum;
        if (!ForbiddenUserType.includes(userType)) {
            return user.sub;
        } else if (contract) {
            return contractsRepository.getPersonneFromContract(contract, user);
        } else {
            return undefined;
        }
    }
}

export const personRepository = new PersonRepository(getAppConfig().b2r.url);
